import React, {createRef, useState, useContext} from 'react';
// import MaterialTable from "material-table";
import {Grid, TablePagination, Checkbox, FormGroup, FormControlLabel} from '@material-ui/core';
import {tableIcons} from '../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../util/Rest';
import {useDispatch} from 'react-redux';
import {defaultRows} from '../../../../constants/ReusableTablePagination';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../constants/ReusableConstants';

export default function EventTacticSearchTable({
  searchData,
  setEventClientData,
  eventClientData,
}) {
  const columns = [
    {
      title: 'Event Tactic Code',
      field: 'code',
    },
    {
      title: 'Event Tactic Description',
      field: 'description',
      width: '2%',
      headerStyle: {textAlign: 'left', fontSize: 16},
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 500,
              textAlign: 'justify',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData.description}
          </div>
        </>
      ),
    },
    {
      title: 'Mode',
      field: 'mode',
    },
  ];
  const [countTotal, setCountTotal] = useState('');
  const tableRef = createRef();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);


  return (
    <>
      <Grid item xs={12} className="">
        <div className="custom-table">
          <GuiTable
            title={
              <div>
                {countTotal && (
                  <p className={classes.searchText}>
                    We found {`"${countTotal}"`} {countTotal === 1 ? 'result' : 'results'}
                  </p>
                )}
              </div>
            }
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `event/search/all`;
                const bodyObj = {
                  code: searchData?.code ? searchData.code : '',
                  description: searchData?.description ? searchData?.description : '',
                  limit: query.pageSize ? query.pageSize : null,
                  page:
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const newObj = {};

                        eventClientData?.length > 0 &&
                          // deepcode ignore ForEachReturns: <please specify a reason of ignoring this>
                          eventClientData?.forEach((el) => {
                            if (!newObj[el.code]) {
                              return (newObj[el.code] = el);
                            }
                          });
                        const newRow = response.data.response.resultObject.map((elem) => {
                          if (newObj[elem.code]) {
                            return {...elem, tableData: {...elem.tableData, checked: true}};
                          } else {
                            return {
                              ...elem,
                              tableData: {...elem.tableData, checked: false},
                            };
                          }
                        });
                        resolve({
                          data: newRow.length > 0 ? newRow : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setCountTotal(response.data.response.count);
                        setArrayLast(response.data.response.resultObject.length === 1);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              toolbar: false,
              search: false,
              selection: true,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[]}
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
            }}
            onSelectionChange={(rows, unSelected) => {
              if (unSelected?.tableData?.checked) {
                setEventClientData([
                  ...eventClientData,
                  {
                    ...unSelected,
                    fieldCode: unSelected.code,
                    ...getFields({...unSelected, fieldCode: unSelected.code}),
                    tableData: {...unSelected.tableData, id: unSelected.code},
                  },
                ]);
              } else {
                const updatedRows = [...eventClientData]
                  .filter((ele) => {
                    return ele.code !== unSelected.code;
                  })
                  .map((ele) => {
                    return {...ele, tableData: {...ele.tableData, id: ele.code}};
                  });
                setEventClientData(updatedRows);
              }
            }}
          />
        </div>
      </Grid>
    </>
  );
}

export const getFields = (unSelected) => {
  return {
    seqNo: (
      values = {},
      handleChange,
      touched = {},
      errors = {},
      inputFieldValues,
      setInputFieldValues,
      setFieldValue,
    ) => {
      return (
        <>
          <div className="format-field" key={unSelected.fieldCode}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    name={'checkBox' + unSelected.fieldCode}
                    onChange={(e) => {
                      setFieldValue('seqNo' + unSelected.fieldCode, e.target.value);
                    }}
                  />
                }
              />
            </FormGroup>
          </div>
        </>
      );
    },
  };
};
